import { FC, useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useReward } from 'react-rewards'
import { useHistory, useLocation } from 'react-router-dom'
import { CheckIcon } from 'lucide-react'
import { useApolloClient } from '@apollo/client'
import { Spinner } from '../../components'
import { confirmUserCourseOrder } from '../../graphql'
import { ROUTES } from '../../utils'
import { StyledConfirmationView } from '.'

type ParamsType = {
  course_name: string
  course_id: string
  course_slug: string
  user_id: string
  email: string
  order: string
  code?: string
}

const ConfirmationView: FC = () => {
  const location = useLocation()
  const history = useHistory()
  const apollo = useApolloClient()
  const [loading, setLoading] = useState(true)
  const [params, setParams] = useState<ParamsType>()
  const { reward } = useReward('confetti', 'confetti', {
    angle: -90,
    startVelocity: 18,
    spread: 220,
    elementCount: 150
  })

  const handleConfirmation = async () => {
    try {
      reward()
      setLoading(true)

      await apollo.mutate({
        fetchPolicy: 'no-cache',
        mutation: confirmUserCourseOrder,
        variables: {
          userId: params?.user_id,
          courseId: params?.course_id,
          order: params?.order,
          coupon: params?.code
        }
      })

      setLoading(false)
    } catch (err) {
      console.error(err)
      toast.error((err as any)?.message)
    }
  }

  useEffect(() => {
    if (!params) {
      return
    }

    handleConfirmation()
  }, [params])

  useEffect(() => {
    const search = new URLSearchParams(location.search)
    const temp = Object.fromEntries(search)
    const { course_name, course_id, course_slug, user_id, email, order, code } = temp

    setParams({
      course_name,
      course_id,
      course_slug,
      user_id,
      email,
      order,
      code
    })
  }, [location.search])

  return (
    <StyledConfirmationView>
      <div className="confirmation-container">
        <div className="icon">
          <CheckIcon />
        </div>
        <h1>Order Successful</h1>
        <p>Thanks for purchasing {params?.course_name}.</p>
        <button
          className="order-btn"
          onClick={() => history.push(ROUTES.course.byLesson(params?.course_slug || '', 'start'))}
          disabled={loading}
        >
          {loading && (
            <>
              <Spinner />
              Granting course...
            </>
          )}
          {!loading && 'Open course'}
        </button>
      </div>
    </StyledConfirmationView>
  )
}

export default ConfirmationView
